// ** MUI Imports
import Box from "@mui/material/Box";

// ** Router
import { useNavigate, useLocation } from "react-router-dom";
import { pathWithPreservedSearch } from "src/@core/utils/urlQueryPreservation";

// ** Components
import ModeToggler from "src/@core/layouts/components/shared-components/ModeToggler";
import UserDropdown from "src/layouts/components/UserDropdown";

const AppBarContent = (props) => {
  // ** Props
  const { settings, saveSettings } = props;

  // ** Hooks
  const navigate = useNavigate();
  const location = useLocation();

  // With the vertical side menu removed (see themeConfig.navHidden), the
  // brand lives here on the left of the AppBar so the top bar reads as
  // intentional. Clicking it returns to the courses home.
  return (
    <Box sx={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <Box
        className="actions-left"
        sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        onClick={() => navigate(pathWithPreservedSearch("/home", location.search))}
      >
        <Box
          component="img"
          src="/images/logos/logo-horizontal.png"
          alt="SalesPark Academy"
          sx={{ height: 38, display: "block" }}
        />
      </Box>
      <Box className="actions-right" sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <ModeToggler settings={settings} saveSettings={saveSettings} />
        <UserDropdown settings={settings} />
      </Box>
    </Box>
  );
};

export default AppBarContent;
